import React from 'react';
import './styles.css';

const Majors = ({ majors: facilities, loading, showTitle = true }) => {
  return (
    <section className="section">
      <div className="container">
        {showTitle && (
          <>
            <h2>Fasilitas Unggulan & Penunjang Akademik</h2>
            <p className="page-intro-text" style={{textAlign: 'center', maxWidth: '800px', margin: '0 auto 40px auto'}}>
              Kami menyediakan beragam fasilitas modern untuk mendukung proses belajar mengajar dan pengembangan potensi siswa secara maksimal, memastikan setiap siswa mendapatkan pengalaman belajar terbaik.
            </p>
          </>
        )}
        {loading ? (
          <p style={{ textAlign: 'center' }}>Memuat data fasilitas...</p>
        ) : facilities && facilities.length > 0 ? (
          <div className="majors-grid">
            {facilities.map((facility) => (
              <div key={facility.id} className="major-card">
                <img src={facility.image || 'https://via.placeholder.com/400x220'} alt={facility.title} className="major-image" loading="lazy" />
                <div className="major-content">
                  <h3>{facility.title}</h3>
                  <div className="major-card-description" dangerouslySetInnerHTML={{ __html: facility.description?.replace(/\n/g, '<br />') || '' }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ textAlign: 'center' }}>Data fasilitas unggulan belum tersedia saat ini.</p>
        )}
      </div>
    </section>
  );
};

export default Majors;